<div class="advanced-filter">
  <nz-collapse nzExpandIconPosition="'right'">
    <nz-collapse-panel
      *ngFor="let panel of advancedFilterPanels"
      class="facet-panel"
      [nzHeader]="panel.name"
      [(nzActive)]="panel.active"
      [nzDisabled]="false"
      (nzActiveChange)="onActiveChange()"
    >
      <!-- <ng-container
        [ngTemplateOutlet]="this[panel.filterType]"
        [ngTemplateOutletContext]="{
          panel: panel,
        }"
      >
      </ng-container> -->
      <div *ngIf="panel.showSearch">
        <app-facet-filter-search
          [facetCategorySearch]="facetCategorySearch"
          [loading]="loading"
          [panel]="panel"
          [activePanel]="activePanel"
          [refreshCurrentPanel]="refreshCurrentPanel"
          [placeholderValues]="placeholderValues"
          (onKeyUp)="onFacetCategorySearch(panel)"
        ></app-facet-filter-search>
      </div>
      <ng-container [ngSwitch]="panel.key">
        <div *ngSwitchCase="'peak_sales'" class="filter-wrapper">
          <app-peak-sales-filter
            *ngIf="facetData.peak_sales"
            [loading]="loading"
            [activePanel]="activePanel"
            [refreshCurrentPanel]="refreshCurrentPanel"
            [panel]="panel"
            [amountFormatter]="amountFormatter"
            [data]="facetData.peak_sales"
            [facetFilter]="facetFilter.peak_sales"
            (onChange)="onFilterChange(panel.key, $event)"
          ></app-peak-sales-filter>
        </div>
        <app-drug-revenue-filter
          *ngSwitchCase="'drug_revenue'"
          [loading]="loading"
          [activePanel]="activePanel"
          [refreshCurrentPanel]="refreshCurrentPanel"
          [panel]="panel"
          [amountFormatter]="amountFormatter"
          [data]="facetData.drug_revenue"
          [facetFilter]="facetFilter.drug_revenue"
          (onChange)="onFilterChange(panel.key, $event)"
          (onUpdateGraph)="onUpdateGraph($event)"
        ></app-drug-revenue-filter>
        <div *ngSwitchCase="'approval_date'" class="filter-wrapper">
          <app-range-filter
            [loading]="loading"
            [activePanel]="activePanel"
            [refreshCurrentPanel]="refreshCurrentPanel"
            [panel]="panel"
            [data]="facetData.approval_date"
            [facetFilter]="facetFilter.approval_date"
            (onChange)="onFilterChange(panel.key, $event)"
          ></app-range-filter>
        </div>
        <div *ngSwitchCase="'expiry_date'" class="filter-wrapper">
          <app-range-filter
            [loading]="loading"
            [activePanel]="activePanel"
            [refreshCurrentPanel]="refreshCurrentPanel"
            [panel]="panel"
            [data]="facetData.expiry_date"
            [facetFilter]="facetFilter.expiry_date"
            (onChange)="onFilterChange(panel.key, $event)"
          ></app-range-filter>
        </div>
        
        <div
          *ngSwitchCase="'market_cap'"
          class="launch-year-filter"
        >
          <div
            *ngIf="
              loading &&
              ((activePanel === panel.key && refreshCurrentPanel) ||
                activePanel !== panel.key)
            "
          >
            <va-custom-skeleton></va-custom-skeleton>
          </div>
          <div *ngIf="!loading || (activePanel == panel.key && !refreshCurrentPanel)">
            <!-- <app-pharma-slider-filter
              *ngIf="facetData.market_cap"
              label="Market Cap"
              [showLabel]="true"
              [min]="facetData.market_cap.min || '' "
              [max]="facetData.market_cap.max || '' "
              [selectedMin]="(facetFilter && facetFilter.market_cap && facetFilter.market_cap.selected_min)
                || facetData.market_cap.min || '' "
              [selectedMax]="(facetFilter && facetFilter.market_cap && facetFilter.market_cap.selected_max)
                || facetData.market_cap.max || '' "
              (onSelectionChange)="onLaunchYearChange(panel.key, $event)"
            ></app-pharma-slider-filter> -->
            <app-graph-slider
              *ngIf="facetData.market_cap"
              [xSeries]="facetData.market_cap.drug_mcap"
              [ySeries]="facetData.market_cap.no_of_drugs"
              [min]="facetData.market_cap.min || '' "
              [max]="facetData.market_cap.max || '' "
              label="Market Cap"
              [magnitude]="facetData.market_cap.magnitude"
              [currency]="facetData.market_cap.currency"
              [selectedMin]="(facetFilter && facetFilter.market_cap && facetFilter.market_cap.selected_min)
                || facetData.market_cap.min || '' "
              [selectedMax]="(facetFilter && facetFilter.market_cap && facetFilter.market_cap.selected_max)
                || facetData.market_cap.max || '' "
              (onSelectionChange)="onLaunchYearChange(panel.key, $event)"
            ></app-graph-slider>
          </div>
        </div>
        <div
          *ngSwitchCase="'rating'"
          class="launch-year-filter"
        >
          <div
            *ngIf="
              loading &&
              ((activePanel === panel.key && refreshCurrentPanel) ||
                activePanel !== panel.key)
            "
          >
            <va-custom-skeleton></va-custom-skeleton>
          </div>
          <div *ngIf="!loading || (activePanel == panel.key && !refreshCurrentPanel)">
            <app-pharma-slider-filter
              label="Average Rating Consensus"
              [showLabel]="true"
              min="1.0"
              max="5.0"
              step="0.1"
              [selectedMin]="(facetFilter && facetFilter.rating && facetFilter.rating.selected_min)
                || 1.0 "
              [selectedMax]="(facetFilter && facetFilter.rating && facetFilter.rating.selected_max)
                || 5.0 "
              (onSelectionChange)="onLaunchYearChange(panel.key, $event)"
            ></app-pharma-slider-filter>
          </div>
        </div>
        <div
          *ngSwitchCase="'launch_year'"
          class="launch-year-filter"
        >
          <div
            *ngIf="
              loading &&
              ((activePanel === panel.key && refreshCurrentPanel) ||
                activePanel !== panel.key)
            "
          >
            <va-custom-skeleton></va-custom-skeleton>
          </div>
          <div *ngIf="!loading || (activePanel == panel.key && !refreshCurrentPanel)">
            <app-pharma-slider-filter
              *ngIf="facetData.launch_year"
              label="Year Range"
              [showLabel]="true"
              [min]="facetData.launch_year.min_year || '' "
              [max]="facetData.launch_year.max_year || '' "
              step="1"
              [selectedMin]="(facetFilter && facetFilter.launch_year && facetFilter.launch_year.selected_min)
                || facetData.launch_year.min_year || '' "
              [selectedMax]="(facetFilter && facetFilter.launch_year && facetFilter.launch_year.selected_max)
                || facetData.launch_year.max_year || '' "
              (onSelectionChange)="onLaunchYearChange(panel.key, $event)"
            ></app-pharma-slider-filter>
          </div>
        </div>
        <div *ngSwitchCase="'drug_type'" class="filter-wrapper">
          <app-facet-checkbox-filter
            [loading]="loading"
            [panel]="panel"
            [activePanel]="activePanel"
            [refreshCurrentPanel]="refreshCurrentPanel"
            [facetData]="facetData"
            [cachedSelections]="cachedSelections"
            [facetFilter]="facetFilter"
            (onCheckboxOptionChange)="onOptionChange($event)"
          ></app-facet-checkbox-filter>
        </div>
        <div *ngSwitchCase="'drug_class'">
          <app-facet-tree-filter
            [loading]="loading"
            [panel]="panel"
            [activePanel]="activePanel"
            [refreshCurrentPanel]="refreshCurrentPanel"
            [facetData]="facetData"
            [cachedSelections]="cachedSelections"
            [facetCategorySearch]="facetCategorySearch"
            (onPanelExpandChange)="onTreeExpandChange($event)"
            (onPanelHierarchyOptionChange)="onTreeHierarchyOptionChange($event)"
          ></app-facet-tree-filter>
        </div>
        <div *ngSwitchCase="'delivery_mechanism'">
          <app-facet-tree-filter
            [loading]="loading"
            [panel]="panel"
            [activePanel]="activePanel"
            [refreshCurrentPanel]="refreshCurrentPanel"
            [facetData]="facetData"
            [cachedSelections]="cachedSelections"
            [facetCategorySearch]="facetCategorySearch"
            (onPanelExpandChange)="onTreeExpandChange($event)"
            (onPanelHierarchyOptionChange)="onTreeHierarchyOptionChange($event)"
          ></app-facet-tree-filter>
        </div>
        <div *ngSwitchCase="'parent_co_financials'" class="filter-wrapper">
          <app-pharma-financial-filter
            *ngIf="facetData.parent_co_financials"
            [amountFormatter]="amountFormatter"
            [loading]="loading"
            [activePanel]="activePanel"
            [refreshCurrentPanel]="refreshCurrentPanel"
            [panel]="panel"
            [data]="facetData.parent_co_financials"
            [filter]="facetFilter.parent_co_financials"
            (onChange)="onFilterChange(panel.key, $event)"
          ></app-pharma-financial-filter>
        </div>
        <app-pharma-valuation-filter
          *ngSwitchCase="'valuation_ratios'"
          [loading]="loading"
          [activePanel]="activePanel"
          [refreshCurrentPanel]="refreshCurrentPanel"
          [panel]="panel"
          [amountFormatter]="amountFormatter"
          [data]="facetData.valuation_ratios"
          [filter]="facetFilter.valuation_ratios"
          (onChange)="onFilterChange(panel.key, $event)"
        ></app-pharma-valuation-filter>
        <div
          *ngSwitchCase="'price_target'"
          class="launch-year-filter"
        >
          <div
            *ngIf="
              loading &&
              ((activePanel === panel.key && refreshCurrentPanel) ||
                activePanel !== panel.key)
            "
          >
            <va-custom-skeleton></va-custom-skeleton>
          </div>
          <div *ngIf="(!loading || (activePanel == panel.key && !refreshCurrentPanel)) && facetData && facetData.price_target">
            <!-- <app-graph-slider
              *ngIf="facetData && facetData.price_target"
              [xSeries]="facetData.price_target.price_targets"
              [ySeries]="facetData.price_target.no_of_companies"
              [min]="facetData.price_target.min"
              [max]="facetData.price_target.max"
              label="Up/Downside from Current Price"
              [magnitude]="facetData.price_target.magnitude"
              [currency]="facetData.price_target.currency"
              [selectedMin]="(facetFilter && facetFilter.price_target.selected_min)|| facetData.price_target.min"
              [selectedMax]="(facetFilter && facetFilter.price_target.selected_max) || facetData.price_target.max"
              [amountFormatter]="amountFormatter"
              (onSelectionChange)="onSliderFilterChange(panel.key, $event)"
            ></app-graph-slider> -->
            <app-pharma-slider-filter
              *ngIf="!loading || (activePanel == panel.key && !refreshCurrentPanel)"
              label="Up/Downside from Current Price"
              [showLabel]="true"
              [min]="facetData.price_target.min"
              [max]="facetData.price_target.max"
              step="0.1"
              [magnitude]="facetData.price_target.magnitude"
              [currency]="facetData.price_target.currency"
              [selectedMin]="(facetFilter && facetFilter.price_target.selected_min)|| facetData.price_target.min"
              [selectedMax]="(facetFilter && facetFilter.price_target.selected_max) || facetData.price_target.max"
              [isDisabled]="facetData.price_target.isDisabled"
              [valueFormatter]="amountFormatter"
              (onSelectionChange)="onSliderFilterChange(panel.key, $event)"
            ></app-pharma-slider-filter>
          </div>
        </div>
      </ng-container>
      <!-- <ng-template #peakSalesTemplate>
        <app-peak-sales-filter
          [loading]="loading"
          [amountFormatter]="amountFormatter"
          [data]="data.peakSales"
          (onChange)="onFilterChange(panel.key, $event)"
        ></app-peak-sales-filter>
      </ng-template>

      <ng-template #drugRevenueTemplate>
        <app-drug-revenue-filter
          [loading]="loading"
          [amountFormatter]="amountFormatter"
          [data]="data.drug_revenue"
          (onChange)="onFilterChange(panel.key, $event)"
        ></app-drug-revenue-filter>
      </ng-template>
      <ng-template #approval_dateTemplate>
        <app-range-filter
          [loading]="loading"
          [data]="data.approval_date"
          (onChange)="onFilterChange(panel.key, $event)"
        ></app-range-filter>
      </ng-template>
      <ng-template #expiry_dateTemplate>
        <app-range-filter
          [loading]="loading"
          [data]="data.expiry_date"
          (onChange)="onFilterChange(panel.key, $event)"
        ></app-range-filter>
      </ng-template> -->
    </nz-collapse-panel>
    
    <ng-template
      #amountFormatter
      let-amount="amount"
      let-magnitude="magnitude"
      let-currency="currency"
    >
      <!-- <span>{{amount}}</span> -->
      <span *ngIf="amount >= 0">{{currency}}{{formatAmount(amount)}}{{magnitude}}</span>
      <span *ngIf="amount < 0" class="negative-value">
        {{currency}}({{formatAmount(amount)}}){{magnitude}}
      </span>
    </ng-template>
  </nz-collapse>
</div>